import { useState } from "react";
//import BgHero from "../assets/Gallery_Nexus/backimage.png";
import EnquiryModal from "../components/EnquiryModal.jsx";
import DonateModal from "../components/DonateModal.jsx";


function Hero() {
  const [selectedService, setSelectedService] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
    const [showEnquiry, setShowEnquiry] = useState(false);
    const [openDonate, setOpenDonate] = useState(false);

  const services = [
    { id: "therapy", icon: "💬", label: "Therapy", desc: "1-on-1 counseling" },
    { id: "group", icon: "👥", label: "Group Sessions", desc: "Community support" },
    { id: "wellness", icon: "🧘", label: "Wellness", desc: "Mindfulness & fitness" },
    { id: "crisis", icon: "🆘", label: "Crisis Support", desc: "24/7 hotline" },
  ];

  const stats = [
    { number: "650+", label: "Clients Helped" },
    { number: "115+", label: "Expert Therapists" },
    { number: "98%", label: "Satisfaction Rate" },
  ];

  return (
      <div className="min-h-screen pt-32 md:pt-36 lg:pt-40 pb-20 bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 glossy-hero relative overflow-hidden">  {/* Background image (hero-only) */}
      <div className="absolute inset-x-0 top-0 h-[780px] mx-auto w-full max-w-7xl overflow-hidden z-0">
        <div className="absolute inset-x-4 top-2 md:inset-x-6 md:top-4 h-[calc(100%-1rem)] md:h-[calc(100%-2rem)] rounded-[2.2rem] border border-white/20 shadow-[0_30px_80px_rgba(0,0,0,0.55)] overflow-hidden">
          {/*<img src={BgHero} alt="Hero background" className="h-full w-full object-cover opacity-100" />*/}
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/10 via-transparent to-slate-950/30" />
        </div>
      </div>
      {/* Animated background gradient overlay */}
      <div className="absolute inset-x-0 top-0 h-[780px] opacity-10 z-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-10 right-1/4 w-96 h-96 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full blur-3xl animate-pulse" style={{ animationDelay: "1s" }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Hero Header */}
        <div className="text-center mb-16 animate-fade-in">
         

          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Your Mental Health
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-orange-400 highlight">
              Journey Starts Here
            </span>
          </h1>

          <p className="text-lg md:text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
            Connect with licensed therapists, join supportive communities, and access wellness tools—all in one place. Take the first step toward better mental health today.
          </p>

          {/* Search Bar */}
          <div className="flex flex-col md:flex-row gap-3 justify-center mb-12">
            <input
              type="text"
              placeholder="What are you looking for? (e.g., anxiety, depression, stress)"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="px-6 py-3 rounded-full border border-cyan-500/40 bg-slate-800/70 focus:outline-none focus:ring-2 focus:ring-cyan-400 flex-1 max-w-md text-slate-200 placeholder-slate-400"
            />
            <button className="glossy-btn relative px-8 py-3 rounded-full font-semibold hover:shadow-lg transform hover:scale-105 transition">
              Search Services
            </button>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
                      <button onClick={() => setOpenDonate(true)} className="glossy-btn relative px-8 py-4 rounded-full font-bold text-lg hover:shadow-xl transform hover:scale-105 transition">
                          Donate Now
            </button>
                      <button onClick={() => setShowEnquiry(true)} className="bg-slate-700/50 border-2 border-cyan-400 text-cyan-300 px-8 py-4 rounded-full font-bold text-lg hover:bg-slate-700 hover:border-cyan-300 transition">
                          Enquire Now
            </button>
          </div>
        </div>
       <EnquiryModal isOpen={showEnquiry} onClose={() => setShowEnquiry(false)} />
       <DonateModal isOpen={openDonate} onClose={() => setOpenDonate(false)} />

        {/* Service Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16 px-6">
          {services.map((service, idx) => (
            <div
              key={service.id}
              onClick={() => setSelectedService(service.id)}
              className={`p-6 rounded-2xl cursor-pointer transition transform hover:scale-105 ${
                selectedService === service.id || selectedService === "all"
                  ? "bg-gradient-to-br from-orange-500 to-orange-600 text-white shadow-xl"
                  : "bg-slate-800/60 text-slate-100 hover:shadow-lg border border-cyan-500/20"
              }`}
              style={{
                animation: `slideUp 0.6s ease-out ${idx * 0.1}s both`,
              }}
            >
              <div className="text-4xl mb-3">{service.icon}</div>
              <h3 className="text-xl font-bold mb-2">{service.label}</h3>
              <p className="text-sm opacity-90">{service.desc}</p>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 bg-slate-800/60 backdrop-blur-md p-8 rounded-3xl shadow-lg border border-cyan-500/20">
          {stats.map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-orange-400 mb-2 highlight">
                {stat.number}
              </div>
              <p className="text-slate-300 text-lg">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Testimonial Card */}
        <div className="bg-gradient-to-r from-cyan-500/10 to-orange-500/10 border-l-4 border-cyan-400 p-8 rounded-2xl mb-12 max-w-2xl mx-auto glossy-card bg-sheen">
          <div className="flex items-start gap-4">
            <div className="text-3xl">⭐⭐⭐⭐⭐</div>
            <div>
              <p className="text-slate-200 italic mb-3 text-lg">
                "This platform changed my life. The therapists are incredibly caring and professional. I finally feel understood."
              </p>
              <p className="text-slate-400 font-semibold">— Chandresh S., Client since 2013</p>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-6 text-center text-slate-400 text-sm md:text-base">
          <div className="flex items-center gap-2">
            <span>🔒</span>
            <span>HIPAA Compliant</span>
          </div>
          <div className="flex items-center gap-2">
            <span>✓</span>
            <span>Licensed Therapists</span>
          </div>
          <div className="flex items-center gap-2">
            <span>💬</span>
            <span>Available 24/7</span>
          </div>
          <div className="flex items-center gap-2">
            <span>🌍</span>
            <span>Global Support</span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }
        .text-cyan-300 { color: #06b6d4; }
        .text-orange-400 { color: #fb923c; }
      `}</style>
    </div>
  );
}

export default Hero;